import * as THREE from "three";
import {
  OrbitControls
} from 'three/examples/jsm/controls/OrbitControls.js';
import {
  GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader.js';
import {
  DRACOLoader
} from 'three/examples/jsm/loaders/DRACOLoader.js'
import fragmentNoise from "./shader/fragmentNoise.glsl";
import vertex from "./shader/vertex.glsl";
const createInputEvents = require('simple-input-events');
import bg from '../../img/bg.png'
import noise from '../../img/noise.png'


// scenes
import Selected from './selectedScene'
import Orbit from './orbitScene'

function lerp(a, b, n) {
  return (1 - n) * a + n * b;
}

function r(a, b) {
  return lerp(a, b, Math.random())
}


const PALLETTE = [
  new THREE.Color(0.119, 0.488, 0.775),
  new THREE.Color(0.126, 0.330, 0.791),
  new THREE.Color(0.120, 0.278, 0.727),
  new THREE.Color(0.077, 0.195, 0.571),
  new THREE.Color(0.092, 0.190, 0.555),
]

export default class Sketch {
  constructor(options) {
    this.container = options.dom;
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;

    this.scene = new THREE.Scene();
    this.sceneNoise = new THREE.Scene();


    

    
    this.renderer = new THREE.WebGLRenderer({
      transparent: true,
      alpha: true,
      antialias: true
    });

    this.renderer.autoClear = false

    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    this.renderer.setSize(this.width, this.height);
    this.renderer.setClearColor(0xeeeeee, 1); 
    this.renderer.physicallyCorrectLights = true;
    this.renderer.outputEncoding = THREE.sRGBEncoding;
    this.event = createInputEvents(this.renderer.domElement);

    this.container.appendChild(this.renderer.domElement);

    this.camera = new THREE.PerspectiveCamera(
      50,
      this.width / this.height,
      0.01,
      100
    );

    this.scroll = 0;
    this.speed = 0;


    // selected scene
    this.selectedScene = new Selected(this)
    if(!window.isMobile) this.orbitScene = new Orbit(this)
    // this.scene.add(this.selectedScene)
    this.selectedScene.resize(this.width,this.height)
    this.renderer.compile(this.selectedScene.camera, this.selectedScene)
    if(!window.isMobile) this.renderer.compile(this.orbitScene.camera, this.orbitScene)


    // var frustumSize = 10;
    // var aspect = window.innerWidth / window.innerHeight;
    // this.camera = new THREE.OrthographicCamera( frustumSize * aspect / - 2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / - 2, -1000, 1000 );
    this.camera.position.set(0, 0, 1.3);
    // this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    // this.controls = new OrbitControls(this.selectedScene.camera, this.renderer.domElement);
    this.time = 0;

    this.dracoLoader = new DRACOLoader();
    this.dracoLoader.setDecoderPath('https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/js/libs/draco/'); // use a full url path
    this.gltf = new GLTFLoader();
    this.gltf.setDRACOLoader(this.dracoLoader);

    
    this.mouse = new THREE.Vector2(0, 0)
    this.settings()
    this.events()
    // this.addObjects()
    // this.addMiya()
    this.addNoise()
   
    this.render();

    this.setupResize();
    

    // this.renderer.compile(this.scene, this.camera)
    // this.renderer.compile(this.sceneAbout, this.cameraAbout)

  }
  events() {
    this.event.on('move', ({
      uv
    }) => {
      this.mouse.x = -(uv[0] - 0.5) * 0.2;
      this.mouse.y = -(uv[1] - 0.5) * 0.2;

    });
  }

  settings() {
    let that = this;
    this.settings = {
      uColor1: PALLETTE[0].getHexString(),
      uColor2: PALLETTE[1].getHexString(),
      uColor3: PALLETTE[2].getHexString(),
      uColor4: PALLETTE[3].getHexString(),
      uColor5: PALLETTE[4].getHexString(),
      uRotation: 0,
      uRange1: 0.5,
      uRange2: 0.1,
      uScale1: 1,
      uScale2: 1,
      uAmp: 0,
      uNoise: 0.06,
      uNoiseSize: 2,
      uSpeed: 2,
    };
    // this.gui = new GUI();
    // // this.gui.addColor(this.settings, "uColor1").onChange(()=>{
    // //   this.material.uniforms.uColor1.value = new THREE.Color(this.settings.uColor1)
    // // })
    // // this.gui.addColor(this.settings, "uColor2").onChange(()=>{
    // //   this.material.uniforms.uColor2.value = new THREE.Color(this.settings.uColor2)
    // // });
    // // this.gui.addColor(this.settings, "uColor3").onChange(()=>{
    // //   this.material.uniforms.uColor3.value = new THREE.Color(this.settings.uColor3)
    // // });
    // this.gui.addColor(this.settings, "uColor1").onChange((val)=>{
    //   this.m.uniforms.uColor1.value = new THREE.Color(val)
    // })

    // this.gui.addColor(this.settings, "uColor2").onChange((val)=>{
    //   this.m.uniforms.uColor2.value = new THREE.Color(val)
    // })

    // this.gui.addColor(this.settings, "uColor3").onChange((val)=>{
    //   this.m.uniforms.uColor3.value = new THREE.Color(val)
    // })

    // this.gui.addColor(this.settings, "uColor4").onChange((val)=>{
    //   this.m.uniforms.uColor4.value = new THREE.Color(val)
    // })

    // this.gui.addColor(this.settings, "uColor5").onChange((val)=>{
    //   this.m.uniforms.uColor5.value = new THREE.Color(val)
    // })

    // this.gui.add(this.settings, "uNoise", 0, 1, 0.01).onChange((val)=>{
    //   this.materialNoise.uniforms.uNoise.value = val
    // })
    // this.gui.add(this.settings, "uNoiseSize", 0, 4, 0.01).onChange((val)=>{
    //   this.materialNoise.uniforms.uNoiseSize.value = val
    // })
    // this.gui.add(this.settings, "uRotation", 0, 3, 0.01).onChange((val)=>{
    //   // this.material.uniforms.uRotation.value = val
    //   this.m.uniforms.uRotation.value = val
    //   this.mesh.rotation.z = -val;
    // })

    // this.gui.add(this.settings, "uSpeed", 0.1, 5, 0.01).onChange((val)=>{
    //   this.m.uniforms.uSpeed.value = val
    // })
    // this.gui.add(this.settings, "uAmp", 0., 0.3, 0.01).onChange((val)=>{
    //   this.m.uniforms.uAmp.value = val
    // })


    // this.gui.add(this.settings, "uRange1", 0, 1, 0.01).onChange(()=>{
    //   this.material.uniforms.uRange1.value = this.settings.uRange1
    // })
    // this.gui.add(this.settings, "uRange2", 0, 1, 0.01).onChange(()=>{
    //   this.material.uniforms.uRange2.value = this.settings.uRange2
    // })
    // this.gui.add(this.settings, "uScale1", 0, 3, 0.01).onChange(()=>{
    //   this.material.uniforms.uScale1.value = this.settings.uScale1
    // })

    // this.gui.add(this.settings, "uScale2", 0, 3, 0.01).onChange(()=>{
    //   this.material.uniforms.uScale2.value = this.settings.uScale2
    // })
  }

  setupResize() {
    window.addEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer.setSize(this.width, this.height);
    this.camera.aspect = this.width / this.height;
    if(this.selectedScene) this.selectedScene.resize(this.width, this.height)
    if(this.orbitScene) this.orbitScene.resize(this.width, this.height)
    this.camera.updateProjectionMatrix();
  }


  addNoise(){
    let that = this;
    this.materialNoise = new THREE.ShaderMaterial({
      side: THREE.DoubleSide,
      uniforms: {
        time: {value: 0},
        
        ratio: {value: window.devicePixelRatio},
        uNoiseTexture: {value: new THREE.TextureLoader().load(noise)},
        uNoise: {value: 0.06},
        uNoiseSize: {value: 2},
        resolution: {
          value: new THREE.Vector4(this.width,this.height),
        },
      },
      // wireframe: true,
      transparent: true,
      vertexShader: vertex,
      fragmentShader: fragmentNoise,
      // blending: THREE.AdditiveBlending
    });

    this.geometry = new THREE.PlaneGeometry(3,3)

    this.noise = new THREE.Mesh(this.geometry, this.materialNoise);
    this.sceneNoise.add(this.noise);
    this.noise.position.z = 1.1;
  }

  stop() {
    this.isPlaying = false;
  }

  play() {
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.render()
    }
  }

  render() {
    // console.log('main play')
    // if (!this.isPlaying) return;
    this.time += 0.05;
    if(this.material) this.material.uniforms.time.value = this.time/10
    if(this.m) this.m.uniforms.time.value = this.time*0.001;
    if(this.materialNoise) this.materialNoise.uniforms.time.value = this.time/10
    
    
    
    // this.renderer.render(this.scene, this.camera);
    // if(this.selectedScene) console.log(this.selectedScene,this.selectedScene.needsRender)
    if(this.selectedScene && this.selectedScene.needsRender){
      console.log('actually rendering SELECTED')
      this.selectedScene.updateScene();
      this.renderer.render(this.selectedScene, this.selectedScene.camera);
    }

    if(this.orbitScene && this.orbitScene.needsRender && !window.isMobile){
      console.log('actually rendering ORBITS!!!')
      this.orbitScene.update();
      this.renderer.render(this.orbitScene, this.orbitScene.camera);
    }

    // noise
    this.renderer.clearDepth()
    if(!window.isMobile) this.renderer.render(this.sceneNoise, this.camera);
    requestAnimationFrame(this.render.bind(this));
    
  }

}


let canvas = new Sketch({
  dom: document.querySelector("#canvas")
});
window.canvas3d = canvas;